import { Component, inject } from '@angular/core'
import { Router } from '@angular/router'
import { map, Observable } from 'rxjs'

import { Enums } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DialogService } from '@hyperkit'

import { CalendlyService } from '../../modules/shared/services/calendly.service'
import { UserService } from '../../modules/shared/services/user.service'

import { ReactivateDialogComponent } from './reactivate-dialog/reactivate-dialog.component'

@Component({
  standalone: false,
  templateUrl: './premium-gate.component.html',
  styleUrls: ['./premium-gate.component.scss'],
})
export class PremiumGateComponent {
  private dialogService = inject(DialogService)
  private router = inject(Router)
  private calendlyService = inject(CalendlyService)
  private userService = inject(UserService)

  public isRevoked$: Observable<boolean> = this.userService.profile$.pipe(
    map((profile) => profile?.company?.status === Enums.CompanyStatus.REVOKED),
  )

  public talkToCyborg(): void {
    this.calendlyService.talkToCyborg()
  }

  public openDialog(): void {
    const dialogRef: DialogRef = this.dialogService.open(
      ReactivateDialogComponent,
    )

    dialogRef.afterClosed().subscribe((redirect: boolean) => {
      if (redirect) {
        this.router.navigate(['research'])
      }
    })
  }
}
